import {
    amber,
    grey,
    blueGrey,
    brown,
    cyan,
    deepOrange,
    deepPurple,
    green,
    lightGreen,
    teal,
    lime
} from "material-ui/colors";
import i18n from "../i18n";

export function nameToInitials(displayName = "") {
    if (displayName.length === 0) {
        return "A";
    }
    return displayName[0];
}

const colors = [
    amber,
    blueGrey,
    brown,
    cyan,
    deepOrange,
    deepPurple,
    green,
    lightGreen,
    teal,
    lime
];

export function nameToColor(name = "") {
    if (name === "") {
        return grey[500];
    }
    let sum = 0;
    for (let i = 0; i < name.length; i += 1) {
        sum += name.charCodeAt(i);
    }
    return colors[sum % colors.length][500];
}

export function defaultName(displayName = "") {
    if (!displayName) {
        return i18n.t("defaultName.Anonymous");
    }
    return displayName;
}



// WEBPACK FOOTER //
// ./src/utils/userUtils.js